// extracted by mini-css-extract-plugin
module.exports = {"display_pic":"display_pic_Q7l0d"};